module.exports = __webpack_public_path__ + "static/img/charging-image1.48f5e4a9.jpg";